/**
 * @generated SignedSource<<26a0cd01169e8687b52546c96263468a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveInstallment_charge$data = {
  readonly id: string;
  readonly paymentMethods: ReadonlyArray<{
    readonly method?: string;
    readonly subscription?: {
      readonly currentInstallment: {
        readonly charge: {
          readonly brCode: string | null | undefined;
          readonly status: string | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveCob_charge" | "PaymentActiveInstallmentCompleted_charge" | "PaymentActiveInstallmentExpired_charge" | "PaymentActiveInstallmentScheduled_charge">;
        } | null | undefined;
        readonly status: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PaymentActiveInstallment_charge";
};
export type PaymentActiveInstallment_charge$key = {
  readonly " $data"?: PaymentActiveInstallment_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallment_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveInstallment_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentMethods",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "method",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentSubscription",
              "kind": "LinkedField",
              "name": "subscription",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaymentSubscriptionInstallment",
                  "kind": "LinkedField",
                  "name": "currentInstallment",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Charge",
                      "kind": "LinkedField",
                      "name": "charge",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "brCode",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "PaymentActiveCob_charge"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "PaymentActiveInstallmentCompleted_charge"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "PaymentActiveInstallmentExpired_charge"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "PaymentActiveInstallmentScheduled_charge"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "PaymentMethodInstallments",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "02a62a2a2e9a850aa1309f8320735eee";

export default node;
